import React, { useState, useMemo } from 'react';
import FileSaver from 'file-saver';
import ExcelExport from 'jsx/elements/buttons/ExcelExport';
import { usePortfolioTranslation as useLocale } from 'jsx/hooks/useTranslation';
import { parseDate } from 'utils/date';

import { api } from 'api';

export default function ExcelExportButton({ customers, selectedMonitor }) {
  const [loading, setLoading] = useState(false);
  const { t } = useLocale();

  var monitorIDsList = [];
  monitorIDsList.push(selectedMonitor.monitorId);

  const regnos = useMemo(() => customers.map((c) => c.subjectRegno), [customers]);
  async function downloadXlsx() {
    setLoading(true);
    const blob = await api.portfolio.excelExport(regnos, monitorIDsList);
    FileSaver.saveAs(blob, `Creditinfo Vidskiptasafn-${parseDate(new Date())}.xlsx`);
    setLoading(false);
  }

  return (
    <ExcelExport
      onClick={downloadXlsx}
      loading={loading}
      tooltip={t('portfolio_excel_export_tooltip')}
    />
  );
}
